import styled from '@emotion/styled'

export const StyleCard = styled.div`
  border-radius: 8px;
  padding: 20px;
  background: ${(props: any) => props.theme.colors.white};
  display: flex;
  flex-direction: column;
  row-gap: 10px;
`

export const StyleCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  img {
    width: 60px;
    height: 60px;
    border-radius: 50%;
  }
`

export const StyleTimeCard = styled.div`
  background: ${(props: any) => props.theme.colors.primary200};
  border-radius: 8px;
  padding: 10px 15px;
  display: flex;
  align-items: center;
  column-gap: 5px;
`
